import styled from 'styled-components'

export const QuestionTitleWrapper = styled.div`
  display: flex;
  p {
    word-wrap: break-word;
    white-space: pre-wrap;
  }
`
